export const URI_TO_SLUG = {
    t0: 'print-studio',
    t1: 'business-card',
    t2: 'referral-card',
    t3: 'nfc-card',
    t4: 'vcard',
    t5: 'floating-buttons',
    t6: 'qr-code',
    t7: 'link-in-bio',
    t8: 'email-signature',
    t9: 'landing-page',
    t10: 'lead-form',
    t11: 'resume',
}

export const TOOL_GROUPS = [
    {
        id: 'digital',
        title: 'Digital Cards',
        tools: [
            { name: 'Print Studio', slug: 'print-studio', icon: 'print', desc: 'Print-ready card wizard' },
            { name: 'Business Card', slug: 'business-card', icon: 'card', desc: 'Shareable digital card' },
            { name: 'Referral Card', slug: 'referral-card', icon: 'card_user', desc: 'Referral & save flows' },
            { name: 'NFC Card', slug: 'nfc-card', icon: 'phone', desc: 'Tap-to-share NFC pages' },
            { name: 'vCard', slug: 'vcard', icon: 'contact', desc: 'Downloadable contact file' },
            { name: 'Email Signature', slug: 'email-signature', icon: 'email', desc: 'Branded email blocks' },
        ],
    },
    {
        id: 'web',
        title: 'Web Presence',
        tools: [
            { name: 'Link-in-Bio', slug: 'link-in-bio', icon: 'website', desc: 'All links in one page' },
            { name: 'Landing Page', slug: 'landing-page', icon: 'page', desc: 'Conversion-focused pages' },
            { name: 'Resume / CV', slug: 'resume', icon: 'file', desc: 'Online resume builder' },
        ],
    },
    {
        id: 'leads',
        title: 'Lead Generation',
        tools: [
            { name: 'Lead Capture', slug: 'lead-form', icon: 'contact', desc: 'Smart lead forms' },
            { name: 'QR Code', slug: 'qr-code', icon: 'code', desc: 'Trackable QR assets' },
            { name: 'Floating Buttons', slug: 'floating-buttons', icon: 'arrow-right', desc: 'Sticky action buttons' },
        ],
    },
]

const ALL_TOOLS = TOOL_GROUPS.flatMap((group) => group.tools)

export function resolveToolSlug(segment) {
    if (!segment) {
        return 'print-studio'
    }

    if (URI_TO_SLUG[segment]) {
        return URI_TO_SLUG[segment]
    }

    if (ALL_TOOLS.some((tool) => tool.slug === segment)) {
        return segment
    }

    return 'print-studio'
}

export function findToolBySlug(slug) {
    return ALL_TOOLS.find((tool) => tool.slug === slug) || ALL_TOOLS[0]
}

export function slugFromPageUrl(url) {
    const path = (url || '').split('?')[0].replace(/\/$/, '')
    const match = path.match(/\/tools\/([^/]+)/)
    return resolveToolSlug(match?.[1])
}
